import React, { useState, useEffect, useRef } from "react";
import Styles from "./main.module.css";
import { CiSearch } from "react-icons/ci";
import {
    searchCompaniesPublic,
    getAllbanners,
} from "../../../Services/APIrequests";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import defaultIMG from "../../../Assets/defaultimg.png";
import { RotatingLines } from "react-loader-spinner";

const Home_content1 = () => {
    const [searchTerm, setSearchTerm] = useState("");
    // New state to hold search type selected by user
    const [searchType, setSearchType] = useState("Name");
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [banners, setBanners] = useState([]);
    const [bannersLoading, setBannersLoading] = useState(false);
    const [bannersError, setBannersError] = useState(null);
    const popupRef = useRef(null);
    const [apiStatus, setApiStatus] = useState(null); // track API status

    const navigate = useNavigate();

    const removeCurrentOriginPrefix = (url) => {
        const origin = window.location.origin + "/";
        if (
            typeof url === "string" &&
            url.startsWith(origin) &&
            (url.slice(origin.length).startsWith("http://") ||
                url.slice(origin.length).startsWith("https://"))
        ) {
            return url.slice(origin.length);
        }
        return url;
    };

    const handleBannerClick = (bannerUrl) => {
        if (bannerUrl) {
            const cleanedUrl = removeCurrentOriginPrefix(bannerUrl);
            // If it's a full URL, open in new tab
            if (
                cleanedUrl.startsWith("http://") ||
                cleanedUrl.startsWith("https://")
            ) {
                window.open(cleanedUrl, "_blank");
            } else {
                // Internal route
                navigate(cleanedUrl);
            }
        }
    };

    // Function to determine if the search term is a CIN or name (you may keep for your own validation)
    const isCIN = (input) => /^[A-Z0-9]{11,21}$/i.test(input);

    useEffect(() => {
        const fetchBanners = async () => {
            setBannersLoading(true);
            setBannersError(null);

            try {
                const response = await getAllbanners();
                if (response.status === 200) {
                    setBanners(response.data.banners || []);
                } else {
                    setBannersError("Failed to load banners");
                }
            } catch (err) {
                setBannersError("Failed to load banners");
                console.error("Error fetching banners:", err);
            } finally {
                setBannersLoading(false);
            }
        };

        fetchBanners();
    }, []);

    const searchHandler = async () => {
        setError(null);
        setCompanies([]);

        if (searchTerm.trim().length < 1) {
            setShowPopup(false);
            return;
        }

        setShowPopup(true);
        setLoading(true);

        try {
            let queryKey = "";
            switch (searchType) {
                case "cin":
                    queryKey = "id";
                    break;
                case "llp":
                    queryKey = "id";
                    break;
                case "gst":
                    queryKey = "GSTNumber";
                    break;
                case "name":
                    queryKey = "name";
                    break;
                case "pan":
                    queryKey = "PanCard";
                    break;
                case "pf":
                    queryKey = "pfNumber";
                    break;
                case "din":
                    queryKey = "DIN";
                    break;
                default:
                    queryKey = "name";
            }

            // const query = `${queryKey}=${encodeURIComponent(searchTerm)}`;

            const response = await searchCompaniesPublic({
                [queryKey]: searchTerm,
            });
            // if (response.status === 200) {
            //   setCompanies(response.data.companies || []);
            // } else {
            //   setCompanies([]);
            // }
            if (response.status === 200) {
                setApiStatus(response.data.Status); // 👈 store API Status
                if (response.data.Status === 1) {
                    setCompanies(response.data.companies || []);
                } else if (response.data.Status === 2) {
                    setCompanies(
                        response.data.companies?.filter((item) => ({
                            cin: item.companyID,
                            companyName: item.companyName,
                        })) || []
                    );
                } else {
                    setCompanies([]);
                }
            } else {
                setCompanies([]);
            }
        } catch (err) {
            setError("Companies Not Found");
        } finally {
            setLoading(false);
            setShowPopup(true);
        }
    };

    // Debouncing search input
    useEffect(() => {
        const delay = setTimeout(() => {
            // ✅ Only call API if 3 or more characters
            if (searchTerm.trim().length >= 3) {
                searchHandler();
            } else {
                setCompanies([]);
                setShowPopup(false);
            }
        }, 1000); // ⏳ delay set to 2 seconds

        return () => clearTimeout(delay);
    }, [searchTerm, searchType]); // also trigger on searchType change

    // useEffect(() => {
    //   const debounceTimeout = setTimeout(() => {
    //     searchHandler();
    //   }, 500);

    //   return () => clearTimeout(debounceTimeout);
    // }, [searchTerm, searchType]);

    // Handle company click
    // const handleCompanyClick = (cin) => {
    //   const token = sessionStorage.getItem("token");
    //   if (token) {
    //     navigate(`/kohere/Companydetails/${cin}`);
    //   } else {
    //     navigate("/login");
    //   }
    // };

    // const handleCompanyClick = (cin) => {
    //   console.log("Navigating to:", `/kohere/Companydetails/${cin}`);
    //   navigate(`/kohere/Companydetails/${cin}`);
    // };

    const handleCompanyClick = (id, type = "CIN") => {
        navigate(`/kohere/Companydetails/${id}`, { state: { idType: type } });
    };

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getPlaceholderText = () => {
        switch (searchType) {
            case "Name":
                return "Search by Company / LLP / CIN / LLPIN";
            case "cin":
                return "Search by Company / LLP / CIN / LLPIN";
            case "gst":
                return "Enter GST number";
            case "pan":
                return "Enter PAN number";
            case "pf":
                return "Enter PF number";
            case "din":
                return "Enter DIN number";
            default:
                return "Enter company name";
        }
    };

    var settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        initialSlide: 0,
        pauseOnHover: true,
        arrows: true,
    };

    return (
        <div
            className={Styles.Home_search_main_container}
            data-aos="fade-up"
            data-aos-anchor-placement="center-bottom">
            <div className={Styles.Home_search_container1}>
                <div className={Styles.Home_search_slider}>
                    <Slider {...settings}>
                        {bannersLoading && (
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100vh",
                                    }}>
                                    <RotatingLines
                                        height="50"
                                        width="50"
                                        color="#4fa94d"
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    />
                                </div>
                            </div>
                        )}
                        {bannersError && <div>{bannersError}</div>}
                        {!bannersLoading &&
                        !bannersError &&
                        banners.length > 0 ? (
                            banners.map((banner, index) => (
                                <div
                                    key={index}
                                    onClick={() =>
                                        handleBannerClick(banner.bannerUrl)
                                    }>
                                    <img
                                        src={banner.imageUrl}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = defaultIMG;
                                        }}
                                        alt={`Banner ${index}`}
                                        className={Styles.Home_search_homebg}
                                    />
                                </div>
                            ))
                        ) : (
                            <div
                                style={{
                                    backgroundColor: "blue",
                                    color: "white",
                                    textAlign: "center",
                                    padding: "50px 0",
                                }}>
                                No banners available
                            </div>
                        )}
                    </Slider>
                </div>

                <div className={Styles.Home_search_Container2}>
                    <h2 className={Styles.Home_search_Header}>
                        Comprehensive Data Access
                    </h2>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                        <select
                            value={searchType}
                            onChange={(e) => setSearchType(e.target.value)}
                            className={Styles.Home_Search_select}>
                            <option value="name">Name</option>
                            <option value="cin">CIN/LLP/LLPIN</option>
                            {/* <option value="name">Name</option> */}
                            {/* <option value="cin"></option> */}
                            <option value="gst">GST</option>
                            <option value="pan">PAN Card</option>
                            <option value="pf">EPFO Number</option>
                            <option value="din">DIN</option>
                        </select>
                        <div className={Styles.Home_Search_box}>
                            {/* Dropdown for selecting search type */}
                            <input
                                type="text"
                                placeholder={getPlaceholderText()}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ flexGrow: 1 }}
                            />

                            <CiSearch
                                className={Styles["Home_Search_icon_search"]}
                                size={25}
                            />
                        </div>
                    </div>
                </div>
                <div className={Styles["Home_Search_companylist"]}>
                    {showPopup && (
                        <div className={Styles.searchcompanynames}>
                            <div
                                className={Styles.popup}
                                onClick={(event) => event.stopPropagation()}
                                ref={popupRef}>
                                <div className={Styles.popupContent}>
                                    {loading && (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                padding: "20px",
                                            }}>
                                            <RotatingLines
                                                height="40"
                                                width="40"
                                                strokeColor="#4fa94d"
                                                strokeWidth="5"
                                                animationDuration="0.75"
                                                visible={true}
                                            />
                                        </div>
                                    )}
                                    {error && <p>{error}</p>}
                                    {!loading &&
                                        !error &&
                                        companies.length > 0 && (
                                            <>
                                                {apiStatus === 1 && (
                                                    <ul
                                                        className={
                                                            Styles.companyList
                                                        }>
                                                        {companies.map(
                                                            (
                                                                company,
                                                                index
                                                            ) => (
                                                                <li
                                                                    key={index}
                                                                    className={
                                                                        Styles.companyListItem
                                                                    }
                                                                    onClick={
                                                                        () =>
                                                                            handleCompanyClick(
                                                                                company?.CIN,
                                                                                "CIN"
                                                                            ) // 👈 CIN type
                                                                    }>
                                                                    {
                                                                        company?.CompanyName
                                                                    }
                                                                </li>
                                                            )
                                                        )}
                                                    </ul>
                                                )}

                                                {apiStatus === 2 && (
                                                    <ul
                                                        className={
                                                            Styles.companyList
                                                        }>
                                                        {companies.map(
                                                            (
                                                                company,
                                                                index
                                                            ) => (
                                                                <li
                                                                    key={index}
                                                                    className={
                                                                        Styles.companyListItem
                                                                    }
                                                                    onClick={
                                                                        () =>
                                                                            handleCompanyClick(
                                                                                company.cin,
                                                                                "ID"
                                                                            ) // 👈 companyID type
                                                                    }>
                                                                    {
                                                                        company.entityName
                                                                    }
                                                                </li>
                                                            )
                                                        )}
                                                    </ul>
                                                )}
                                            </>
                                        )}

                                    {!loading &&
                                        !error &&
                                        companies.length === 0 &&
                                        searchTerm.length >= 2 && (
                                            <p>No companies found</p>
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Home_content1;
